/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Always show number pad",
  "description": "Show Scratch's number pad input when editing number fields on all devices, instead of only touchscreen devices.",
  "credits": [
    {
      "name": "GarboMuffin"
    }
  ],
  "info": [
    {
      "text": "A number pad will show when editing number inputs from certain blocks, such as \"set x to\".",
      "id": "explanation"
    }
  ],
  "tags": [
    "new"
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "dynamicDisable": true
};
export default manifest;
